module.exports = __webpack_public_path__ + "static/img/no-record_icon.a1daaff3.png";